import { HttpStatusCode } from "types/types";

import { type DaperClientErrorParams, type DaperErrorResponse } from "./types";

export class DaperClientError extends Error {
  url: string;
  errorResponse: DaperErrorResponse;
  status: HttpStatusCode;

  constructor({ errorResponse, status, url }: DaperClientErrorParams) {
    super(JSON.stringify(errorResponse));
    this.name = "DaperClientError";
    this.status = status;
    this.url = url;
    this.errorResponse = errorResponse;
  }
}
